<template>
   <div id="step2">

      <div class="wrapper stepUp ">
          <div class="d23"></div>
      <div class= "formaWrap">
      <div class= "step">
        <p class= "stepWrap">1</p>
        <svg width="7" height="29" viewBox="0 0 7 29" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'nextstep'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.875 28.216a.593.593 0 01-.558-.794l4.586-12.739a1.4 1.4 0 000-.948L.317.996A.593.593 0 011.433.594l4.73 13.14a1.4 1.4 0 010 .95l-4.73 13.14a.593.593 0 01-.558.392z" fill="#000F38" fill-opacity=".2"/></svg>
        <p class= "stepWrap current">2</p>
        <svg width="7" height="29" viewBox="0 0 7 29" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'nextstep'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.875 28.216a.593.593 0 01-.558-.794l4.586-12.739a1.4 1.4 0 000-.948L.317.996A.593.593 0 011.433.594l4.73 13.14a1.4 1.4 0 010 .95l-4.73 13.14a.593.593 0 01-.558.392z" fill="#000F38" fill-opacity=".2"/></svg>
        <p class= "stepWrap">3</p>
        </div>
      <p class="fillContact">Укажите адрес проживания</p>
        <form action="" v-show="control">
            <ul>
                <li>
                  <selectDadata
                    :label="'Фактический адрес'"
                    :refs="'residentialAddress'"


                  ></selectDadata>

                </li>

                <li>
                  <selectDadata

                  :label="'Адрес регистрации'"
                  :refs="'registrationAddress'"
                  v-if="!identicalAddresses"
                  >

                  </selectDadata>
                </li>
<div class="flex">
                <input
                type="checkbox"
                id="addressSimilar"

                v-model="identicalAddresses"
                >
                <label for="addressSimilar">Фактический адрес
и aдрес регистрации совпадают</label>
</div>
                </ul>

        </form>
                <button type="button" class="btn" v-on:click.prevent="nextStep" >Далее</button>

      </div>
      </div>
      </div>
</template>

<script>
 import {mapState,mapGetters} from 'vuex'
export default {
  name: 'step2',
  data(){
return{

    // identicalAddresses: false,
    control: true,
    visible: true,
}
},
  components:{
    selectDadata:()=>import('@/components/alfaSelectDadata')
  },
methods: {
  nextStep(){
    let ercount = 0;

    if (this.isAlfaAdressValid('residentialAddress').length > 0) {
      ercount+=1;
      this.$store.dispatch('alfaSetAddressError', {
        key:'residentialAddress',
        msg:this.isAlfaAdressValid('residentialAddress'),
        show:true,
        code:1
      });
        try {
            // eslint-disable-next-line
            ym(82222150, 'reachGoal', '2step')
          }
          catch(e){
            console.log(e)
          }
    }


if(!this.identicalAddresses){
    if (this.isAlfaAdressValid('registrationAddress').length > 0) {
      ercount+=1;
      this.$store.dispatch('alfaSetAddressError', {
        key:'registrationAddress',
        msg:this.isAlfaAdressValid('registrationAddress'),
        show:true,
        code:1
      });
    }
}

    if (ercount == 0) {

      this.$myApi.singleRequest({
        action:'stepSave',
        step:'screen_2',
        stepCode:1,
        session:this.session
      }).then((res)=>{res['asd']='asd';}).catch((res)=>{res['asd']='asd';});

      this.$store.commit('incStepForm');
    }
},
    toggle() {
      this.identicalAddresses = !this.identicalAddresses;
      this.visible=!this.visible
},
},
computed:{
    ...mapState({
      valueVuex: state => state.alfaForm.alfaForm,
      session:state=>state.alfaForm.session,
    }),
  ...mapGetters(['isAlfaAdressValid']),
  identicalAddresses:{
      get(){
        return this.valueVuex['identicalAddresses'];
      },
        set(value){
        this.$store.dispatch('updateAlfaFormValue',{
          parent: '',
          formKey:'identicalAddresses',
          value:value
        })
      }
    },
}

}
</script>

<style scoped>
form{padding-bottom: 46vw;}
label{font-size: 3.5vw; color: rgba(0, 15, 56, 0.6); text-align: start;}
#step2{ height: 140vw;}
button{left: 23vw;position: absolute;bottom: 8vw;}
.flex{display:flex; align-items: center; justify-content: center;margin-left: auto;margin-right: auto;width: 85vw;}
input[type=checkbox]:not(:checked) {
    background-image: url('../assets/vector/radiobutton.svg');
}
input[type=checkbox]:checked {
    background-image: url('../assets/vector/radiobuttoncheck.svg');
}
input[type=checkbox] {
    width: 3vw;
    height: 3vw;
    -webkit-appearance: none;
    outline: 0;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    border:0px;
}
/deep/li input{ margin-bottom: 8vw;}


@media screen and (min-width: 1140px) {
label{font-size: 25px; }
form{padding-bottom: 133px;}
#step2{ height: 674px;}
button{left: 390px;bottom: 40px;}
.flex{width: 770px;}
input[type=checkbox] {
    width: 30px;
    height: 30px;

}
/deep/li input{ margin-bottom: 30px;}



}

</style>
